import { CreateElement, VNode, VueConstructor } from "vue";
import Vue from "vue";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import MessageItem from "./MessageItem";
import SystemMessageCall from "./SystemMessageCall.vue";
import SystemMessageServicePurchase from "./SystemMessageServicePurchase.vue";
import SystemMessageTip from "./SystemMessageTip.vue";

export function getMessageView(message: Message): VueConstructor<Vue> {
  if (Number(message.senderId) > 0) {
    return MessageItem;
  }
  if (message.details?.type === "tip") {
    return SystemMessageTip;
  }
  if (message.details?.type === "call") {
    return SystemMessageCall;
  }
  if (message.details?.type === "creator_service") {
    return SystemMessageServicePurchase;
  }
  return Vue.extend({
    functional: true,
    render: (h: CreateElement): VNode => h(),
  });
}
